import script from "./MerchantStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantStatCard.vue?vue&type=script&setup=true&lang=js"

import "./MerchantStatCard.vue?vue&type=style&index=0&id=0ea6efb8&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea6efb8"]])

export default __exports__